<template>
  <nuttrema-layout-default-slide class="is-lighter" :can-toggle="false">

    <template slot="expanded-menu-level-zero">

      <template v-if="preCompletionPass">
        <nuttrema-sidebar-menu-notice v-if="token" class="is-blue">
          <div slot="center" class="nuttrema-sidebar-menu-notice__bg">
            <img class="image--dc-ballon-sun-cloud" src="/static/svg/thank-you/dc-ballon-sun-cloud.svg" alt="">
          </div>

          <div slot="bottom" class="nuttrema-sidebar-menu-notice__text">
            <h1 class="text--title">{{ $t('label.your_trust_quote') }}</h1>
          </div>
        </nuttrema-sidebar-menu-notice>

        <nuttrema-sidebar-menu-notice v-else>
          <div slot="center" class="nuttrema-sidebar-menu-notice__bg">
            <img class="image--paper-plane-fly" src="~assets/images/paper-plane-fly.svg" alt="">
          </div>

          <div slot="bottom" class="nuttrema-sidebar-menu-notice__text">
            <h1 class="text--title">{{ $t('label.email_send') }}</h1>
            <div class="text--subtitle" v-html="_markdown.render($t('label.we_have_sent_an_email_containing_the_special_link'))"></div>
            <div class="text--notice" v-html="_markdown.render($t('label.didnt_receive_an_email'))"></div>
            <div class="text--link">
              <router-link
                :to="{ name: 'professional-resend-completion-token' }">
                {{ $t('label.purchase_confirmation_email_not_arrive') }}
              </router-link>
            </div>
          </div>
        </nuttrema-sidebar-menu-notice>
      </template>

      <nuttrema-sidebar-menu-notice class="is-grey-storm-clouds"  v-else>
        <div slot="center" class="nuttrema-sidebar-menu-notice__bg"></div>

        <div slot="bottom" class="nuttrema-sidebar-menu-notice__text">
          <h1 class="text--title">{{ $t('label.error_loading') }}</h1>
          <div class="text--subtitle" v-html="_markdown.render($t('label.we_have_sent_an_email_containing_the_special_link'))"></div>
        </div>
      </nuttrema-sidebar-menu-notice>

    </template>


  </nuttrema-layout-default-slide>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, get } from 'lodash';

import NuttremaLayoutDefaultSlide from 'components/ui/layout/nuttrema-layout-default-slide';

import SidebarMenuLevelAuthCollapsed from 'components/ui/menu/auth/sidebar-menu-level-auth-collapsed';
import SidebarMenuLevelAuthExpanded from 'components/ui/menu/auth/sidebar-menu-level-auth-expanded';

import NuttremaRegistrationCarousel from 'components/ui/carousel/nuttrema-registration-carousel';
import NuttremaBrandImage from 'components/ui/images/nuttrema-brand-image';
import NuttremaSidebarMenuNotice from 'components/ui/panels/nuttrema-sidebar-menu-notice';

export default {
  name: 'layout-set-public-thank-you',
  props: {
    token: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaBrandImage,
    NuttremaLayoutDefaultSlide,
    SidebarMenuLevelAuthExpanded,
    SidebarMenuLevelAuthCollapsed,
    NuttremaRegistrationCarousel,
    NuttremaSidebarMenuNotice,
  },
  computed: {
    ...mapGetters([
      'InstanceRegistrationPreCompletion',
    ]),
    preCompletionPass() {
      return isNil(get(this.InstanceRegistrationPreCompletion, 'error'));
    },
  },
  created() {
    if (!isNil(this.token)) {
      this.$store.dispatch('GetProceedInstanceRegistrationPreCompletion', { query: { token: this.token } });
    }
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInstanceRegistrationPreCompletion');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/public/layout-set-public-thank-you.vue